export enum RequestStatusCode {
	UnderStudyFollowUp = "UNDER_STUDY_FOLLOW_UP",
	ReturnedToCompleteStudy = "RETURNED_TO_COMPLETE_STUDY",
	AwaitingCompletion = "AWAITING_COMPLETION",
	PendingSupervisorApproval = "PENDING_SUPERVISOR_APPROVAL",
	ReturnedToSupervisor = "RETURNED_TO_SUPERVISOR",
	PendingDirectorApproval = "PENDING_DIRECTOR_APPROVAL",
	ReturnedToDirector = "RETURNED_TO_DIRECTOR",
	RaisedToMinister = "RAISED_TO_MINISTER",
	PreliminaryDecisionIssued = "PRELIMINARY_DECISION_ISSUED",
	FinalDecisionIssued = "FINAL_DECISION_ISSUED",
	Saved = "SAVED",
	ReferredToPublicProsecution = "REFERRED_TO_PUBLIC_PROSECUTION",
	ReturnedToSbaOversight = "RETURNED_TO_SBA_OVERSIGHT",
	InProcessing = "IN_PROCESSING",
	ReturnedToCompleteProsecutionStatement = "RETURNED_TO_COMPLETE_PROSECUTION_STATEMENT",
	LegalStudyInPreparation = "LEGAL_STUDY_IN_PREPARATION",
	LegalStudyReturned = "LEGAL_STUDY_RETURNED",
	LegalStudyReview = "LEGAL_STUDY_REVIEW",
	AwaitingSessionScheduling = "AWAITING_SESSION_SCHEDULING",
	AwaitingMinutesApproval = "AWAITING_MINUTES_APPROVAL",
	AwaitingMinutesAuthentication = "AWAITING_MINUTES_AUTHENTICATION",
	DecisionDrafting = "DECISION_DRAFTING",
	DecisionDraftingReturned = "DECISION_DRAFTING_RETURNED",
	FirstMemberNotes = "FIRST_MEMBER_NOTES",
	FirstMemberNotesReturned = "FIRST_MEMBER_NOTES_RETURNED",
	SecondMemberNotes = "SECOND_MEMBER_NOTES",
	SecondMemberNotesReturned = "SECOND_MEMBER_NOTES_RETURNED",
	ChairmanApproval = "CHAIRMAN_APPROVAL",
}
